import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from 'reselect'
import { Notes } from 'components/common/Notes'
import { AddNoteModal } from 'components/common/modals/AddNoteModal'
import { toGroupOptions, toFormData } from 'components/Company/serializers'
import * as ACT from 'components/Company/actions'
import s from './CompanyNotes.scss'
import swal from 'sweetalert'
import { PUSH_NOTIFICATION } from 'actions/actionTypes'

const selectContacts = createSelector([state => state.company], company => {
  return toGroupOptions(company.contacts)
})

const CompanyNotes = ({ companyId }) => {
  const [showAddNoteModal, setShowAddNoteModal] = useState(false)
  const [selectedNote, setSelectedNote] = useState(null)

  const contacts = useSelector(state => selectContacts(state))

  const dispatch = useDispatch()
  const notes = useSelector(state => state.company.notes)

  const toggleAddNoteModal = selectedNote => {
    setShowAddNoteModal(!showAddNoteModal)
    setSelectedNote(selectedNote)
  }

  useEffect(() => {
    companyId &&
      dispatch({
        type: ACT.COMPANY_NOTES_FETCH_REQUESTED,
        payload: {
          id: companyId
        }
      })
  }, [companyId, dispatch])

  const addNote = (cb, contact, files, note, dateEntered, destroyEditor) => {
    dispatch({
      type: ACT.COMPANY_ADD_NOTE_REQUESTED,
      payload: {
        data: toFormData(contact, files, note, companyId, dateEntered)
      }
    })
    destroyEditor?.()
    cb?.()
  }

  const updateNote = (noteId, cb, contact, files, note, dateEntered, destroyEditor) => {
    dispatch({
      type: ACT.COMPANY_UPDATE_NOTE_REQUESTED,
      payload: {
        data: toFormData(contact, files, note, companyId, dateEntered),
        noteId
      }
    })
    destroyEditor?.()
    cb?.()
  }

  const deleteNote = async noteId => {
    const willRemove = await swal({
      title: 'Are you sure you want to delete this note?',
      text: 'This action can’t be undone',
      buttons: ['Cancel', 'Yes'],
      icon: 'warning'
    })
    if (willRemove) {
      try {
        dispatch({
          type: ACT.COMPANY_DELETE_NOTE_REQUESTED,
          payload: {
            noteId
          }
        })
      } catch (e) {
        dispatch({
          type: PUSH_NOTIFICATION,
          payload: {
            title: 'There was a problem deleting note',
            level: 'error'
          }
        })
      }
    }
  }

  return (
    <section className={s.notesContainer}>
      <Notes
        notes={notes}
        toggleAddNoteModal={toggleAddNoteModal}
        hideCompay
        deleteNote={deleteNote}
      />
      <AddNoteModal
        toggleAddNoteModal={toggleAddNoteModal}
        showAddNoteModal={showAddNoteModal}
        selectedNote={selectedNote}
        groupedContacts={contacts}
        addNote={addNote}
        updateNote={updateNote}
      />
    </section>
  )
}

export default CompanyNotes
